export const VERIFICATION_KEYS = [
  'contact_email',
  'contact_phone',
  'goverment_issued_id',
  'guide_certificate',
];



// WEBPACK FOOTER //
// ./src/constants/admin.js